import { render, staticRenderFns } from "./TestInstallOrderModal.vue?vue&type=template&id=90960904"
import script from "./TestInstallOrderModal.vue?vue&type=script&lang=js"
export * from "./TestInstallOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports